import type { HTMLAttributes, ReactNode } from 'react';
import './primitives.css';

export function Container({ className = '', children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`land-container ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return <span className="land-eyebrow">{children}</span>;
}

export function Tag({ children }: { children: ReactNode }) {
  return <span className="land-tag">{children}</span>;
}

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  tone?: 'default' | 'tint' | 'accent';
}

export function Card({ tone = 'default', className = '', children, ...rest }: CardProps) {
  const toneClass = tone === 'default' ? '' : `land-card--${tone}`;
  return (
    <div className={`land-card ${toneClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}
